<div class="courier-info-wrapper" [style.--color]="brandColor">
  <div *ngIf="shouldShowContactDriverMessage" class="courier-contact-message" [style.--color]="brandColor">
    <div class="title">Not going to be home?</div>
    <div class="description"><b>Please call</b> your driver to coordinate delivery instructions.</div>
  </div>
  <div class="courier-info">
    <div class="courier-name-and-vehicle">
      <div class="vehicle-type-icon" [style.--color]="brandColor + '0A'" [class.large]="!mobileMode">
        <img [src]="'assets/' + vehicleTypeIcon + '.svg'" alt="vehicle type" />
      </div>
      <div class="courier-name">
        <div class="courier-name-inner">
          <div class="subtitle">Your courier</div>
          <div class="name">{{ courierName }}</div>
          <div *ngIf="courierPhone && !mobileMode" class="desktop-phone">
            <common-phone-icon class="phone-icon" [color]="'#343E57'"></common-phone-icon>
            {{ courierPhone }}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="courierPhone && mobileMode" class="call-courier">
      <a
        [href]="'tel:' + courierPhone"
        trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ orderStatus }}/Contact driver phone">
        <common-phone-icon [color]="textColor"></common-phone-icon>
      </a>
    </div>
  </div>
</div>
